import { render, staticRenderFns } from "./PropertySelectControl.global.vue?vue&type=template&id=da0d689a&lang=pug&"
import script from "./PropertySelectControl.global.vue?vue&type=script&lang=ts&"
export * from "./PropertySelectControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports